import fetch from 'cross-fetch'; // isomorphic fetch for different browsers

const _loadImage = async (url, next) => {
    const img = new Image();
    img.onload = () => next(null, img);
    img.crossOrigin = '';
    img.src = url;
};

export default function corsLoadImage(url, next) {
    if (new window.URL(url).origin === window.location.origin) {
        _loadImage(url, next);
        return;
    }

    try {
        const cacheBustedUrl = `${url}?v=${Date.now()}`;
        fetch(cacheBustedUrl)
            .then((res) => res.blob())
            .then((data) => {
                const reader = new FileReader();
                reader.onload = function onFileLoad() {
                    next(null, this.result);
                };
                reader.readAsDataURL(data);
            })
            .catch((err) => {
                next(err);
            });
    } catch (err) {
        next(err);
    }
}
